<template>
    <div style="background: #f5f5f5">
        <examHeader />
        <el-main class="exam_container">
            <router-view />
        </el-main>
    </div>
</template>

<script>
import examHeader from "@/components/examHeader.vue";
export default {
    name: "Layout",
    components: { examHeader },
};
</script>
<style>
.exam_container {
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
}

@media (max-width: 640px) {
    .exam_container {
        width: 96vw;
        margin: 0 auto;
        box-sizing: border-box;
    }
}
</style>
